import { render, staticRenderFns } from "./Electionricker.vue?vue&type=template&id=3165ff94&scoped=true"
import script from "./Electionricker.vue?vue&type=script&lang=js"
export * from "./Electionricker.vue?vue&type=script&lang=js"
import style0 from "./Electionricker.vue?vue&type=style&index=0&id=3165ff94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3165ff94",
  null
  
)

export default component.exports